<template>
<v-data-table
  :headers="headers"
  :items="allBaskets"
  class="px-5 services-table"
  :page="paginationAllBaskets.page"
  :items-per-page="paginationAllBaskets.page_size"
  :loading="loading.load"
  loading-text="Загрузка... Пожалуйста подождите"
  :mobile-breakpoint="300"
  :height="tableHeight"
  fixed-header
  hide-default-footer
>
  <template v-slot:header>
    <tr>
      <td class="border-bottom pa-3"/>
      <td class="border-bottom pa-3" >
        <div>
          <v-text-field
            label="Фамилия и Имя"
            append-icon="mdi-magnify"
            class="font-sm"
            :dense="true"
            :hide-details="true"
            :outlined="true"
            @input="debounceSetFilters('')"
          />
        </div>
      </td>
      <td class="border-bottom pa-3" >
      </td>
      <td class="border-bottom pa-3" >
        <div>
          <v-text-field
            label="Тесты"
            append-icon="mdi-magnify"
            class="font-sm"
            :dense="true"
            :hide-details="true"
            :outlined="true"
          />
        </div>
      </td>
      <td class="border-bottom pa-3">
        <div>
          <v-text-field
            label="Компания"
            append-icon="mdi-magnify"
            class="font-sm"
            :dense="true"
            :hide-details="true"
            :outlined="true"
          />
        </div>
      </td>
      <td class="border-bottom pa-3">
        <div>
          <v-text-field
            label="Электронная почта"
            append-icon="mdi-magnify"
            class="font-sm"
            :dense="true"
            :hide-details="true"
            :outlined="true"
          />
        </div>
      </td>
    </tr>
  </template>
  <template v-slot:item.user_last_name="{ item }">
    <div>
      {{item.user_last_name}} {{item.user_first_name}}
    </div>
  </template>

  <template v-slot:no-data>
    Корзин пользователей не найдено.
  </template>
  <template v-slot:footer="{ props }">

    <v-data-footer
      :pagination="tablePagination"
      :options="tableOptions"
      items-per-page-text="Пользователей на странице:"
      :items-per-page-options="[10, 20, 50, 100, 500, 1000]"
      :page-text="`Всего пользователей: ${props.pagination.itemsLength}. Страница ${props.options.page} из ${props.pagination.pageCount}`"
      show-current-page
      show-first-last-page
      @update:options="updatePagination"
    />
  </template>
</v-data-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

/**
 * Компонент: TableBaskets
 * Описание:
 */
export default {
  name: 'TableBaskets',

  components: { },

  props: {},

  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
          width: '120px',
        },
        {
          text: 'Фамилия и имя',
          align: 'start',
          value: 'user_last_name',
          width: '240px',
          sortable: true,
        },
        {
          text: 'Услуг в корзине',
          value: 'items_count',
          width: '166px',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Тесты',
          value: '',
          width: '204px',
          sortable: false,

        },
        {
          text: 'Название компании',
          align: 'start',
          value: '',
          width: '240px',
        },
        {
          text: 'Электронная почта',
          align: 'start',
          value: 'user_email',
          width: '240px',
        },
      ],
      tableHeight: 400,
    };
  },

  computed: {
    allowedTests() {
      return [
        { value: '', text: 'Все' },
      ];
    },
    ...mapGetters({
      loading: 'services/services/GET_LOADING_SERVICES',
      allBaskets: 'basket/basket/allBasketsUsers',
      filters: 'basket/basket/filters',
      pagination: 'basket/basket/pagination',
    }),
    paginationAllBaskets() {
      return this.pagination('allBasketsUsers');
    },
    tableOptions() {
      return {
        page: this.paginationAllBaskets.page,
        itemsPerPage: this.paginationAllBaskets.page_size,
      };
    },
    tablePagination() {
      return {
        page: this.paginationAllBaskets.page,
        itemsPerPage: this.paginationAllBaskets.page_size,
        pageCount: this.paginationAllBaskets.totalPage,
        itemsLength: this.paginationAllBaskets.count,
      };
    }
  },

  watch: {

  },

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      setPagination: 'basket/basket/setPaginationBaskets',
    }),
    ...mapMutations({
      setFilters: 'basket/basket/SET_FILTERS',
    }),
    debounceSetFilters(field, value) {
      console.log(field, value);
    },
    async updatePagination(data) {
      if (data.itemsPerPage !== this.paginationAllBaskets.page_size || data.page !== this.paginationAllBaskets.page) {
        const payload = {
          ...this.paginationAllBaskets,
          page: data.page,
          page_size: data.itemsPerPage
        };
        await this.setPagination(payload);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.TableBaskets {
  /* Стили компонента */
}
</style>
